import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/doctorAvatar.svg'


const _hoisted_1 = { class: "flex items-center gap-3 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Avatar do médico",
  class: "w-full h-full rounded-full object-cover"
}, null, -1)
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "font-semibold text-sm text-black" }
const _hoisted_5 = { class: "text-xs text-gray-500" }

import { computed } from 'vue'

import type { QualificationDocumentalDoctor } from '@/Network/Types/Responses/QualificationDocumentalResponses'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'
import { resolveAvatarSrc } from '@/utils/avatar'
import { formatDoctorName } from '@/utils/string'


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorCell',
  props: {
    doctor: {}
  },
  setup(__props: any) {

const props = __props;



const resolvedAvatar = computed(() => resolveAvatarSrc(props.doctor.avatarUrl))

const formattedName = computed(() => formatDoctorName(props.doctor.doctorName))

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_avatar, {
      size: "36",
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createVNode(ProtectedAvatar, {
          src: resolvedAvatar.value,
          size: 36
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(formattedName.value), 1),
        (_ctx.doctor.isOutOfScale)
          ? (_openBlock(), _createBlock(LabelBadge, {
              key: 0,
              label: "Fora da escala",
              color: "orange",
              size: "small",
              icon: null,
              "data-testid": "badge-out-of-scale"
            }))
          : _createCommentVNode("", true),
        (_ctx.doctor.isInvited)
          ? (_openBlock(), _createBlock(LabelBadge, {
              key: 1,
              label: "Convidado",
              color: "blue",
              size: "small",
              icon: null,
              "data-testid": "badge-invited"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", _hoisted_5, "CRM: " + _toDisplayString(_ctx.doctor.crm) + "-" + _toDisplayString(_ctx.doctor.crmUf), 1)
    ])
  ]))
}
}

})